import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getMongoUsageThunk,
  getMediaUsageThunk,
  getTwilioUsageThunk,
} from "../../store/thunks/usageThunks";
import UsageCard from "./components/UsageCard";
import Filter from "../../components/common/Filter";

const UsageDashboard = () => {
  const dispatch = useDispatch();
  const { services, loading, error } = useSelector((state) => state.usage);
  const [currentFilter, setCurrentFilter] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    dispatch(getMongoUsageThunk());
    dispatch(getMediaUsageThunk());
    dispatch(getTwilioUsageThunk());
  }, [dispatch]);

  const handleFilterChange = useCallback((status) => {
    setCurrentFilter(status);
    // Apply filtering logic if needed
  }, []);

  const headerLabels = {
    mongo: "Database",
    media: "Media (images and videos)",
    twilio: "SMS (to send OTP)",
  };

  const filteredServices = useMemo(() => {
    return Object.entries(services)
      .filter(([key, service]) => {
        const isEnabled = service.enabled !== false; // Treat undefined or true as enabled
        const matchesFilter =
          currentFilter === "All" ||
          (currentFilter === "Active" && isEnabled) ||
          (currentFilter === "Inactive" && !isEnabled);
        const matchesSearch = key
          .toLowerCase()
          .includes(searchTerm.toLowerCase());
        return matchesFilter && matchesSearch;
      })
      .map(([key, service]) => ({
        key,
        service,
      }));
  }, [services, currentFilter, searchTerm]);

  return (
    <div className="container mx-auto p-4 bg-background text-text">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">Usage Dashboard</h1>
        <div className="flex items-center">
          <input
            type="text"
            placeholder="Search services..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="p-2 border rounded"
          />
        </div>
      </div>
      <div className="sticky top-0 z-8 bg-background py-2 mb-4">
        <div className="flex flex-col lg:flex-row justify-between items-center mb-2">
          <Filter
            defaultOption="All"
            options={["All", "Active", "Inactive"]}
            onSelect={handleFilterChange}
          />
        </div>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className="grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {filteredServices.length === 0 && (
            <>No service Found for "{currentFilter}" filter</>
          )}
          {filteredServices.map(({ key, service }) => (
            <UsageCard
              key={key}
              serviceKey={key}
              title={headerLabels[key] || service.title || key}
              usage={service.usage}
              limits={service.limits}
              enabled={service.enabled}
            />
          ))}
        </div>
      )}
      {error && (
        <div className="text-center mt-10 text-red-500">Error: {error}</div>
      )}
    </div>
  );
};

export default UsageDashboard;
